import React from 'react';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { Button, MinusIcon } from 'framework/ui/mui-builder';
import { TextInput, EnumDropdown } from 'framework/form';
import {
  HealthZone,
  STAFFING_RISK_STATUS_TYPE,
  StaffingRiskIssue,
  STAFFING_PRIORIRY_ZONES_ALIASES,
  STAFFING_RISK_STATUS,
} from 'domain/shared/staffing';
import { STAFFING_RISK_STATUS_DISPLAY, ZONE_LABELS } from 'domain/staffing/dashboard/constants';

interface StaffingRiskIssueItemProps {
  issue: StaffingRiskIssue & { isNew?: boolean };
  index: number;
  onDescriptionChange: (index: number, value: string) => void;
  onStatusChange: (index: number, status: STAFFING_RISK_STATUS_TYPE) => void;
  onZoneChange: (index: number, zone: HealthZone) => void;
  onRemove: (index: number) => void;
}

const StaffingRiskIssueItem: React.FC<StaffingRiskIssueItemProps> = ({
  issue,
  index,
  onDescriptionChange,
  onStatusChange,
  onZoneChange,
  onRemove,
}) => {
  const isNew = issue.isNew === true;
  const elementId = issue.id ? String(issue.id) : `${index}`;
  const isSystem = issue.systemIssueType != null;

  return (
    <Box mb={1}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid size={isNew ? 8.5 : 7}>
          {isNew ? (
            <TextInput
              source={`issue_${elementId}`}
              label="Issue"
              placeholder="Describe the issue"
              onChangeCallback={(inputData: any) => {
                onDescriptionChange(index, inputData[`issue_${elementId}`]);
              }}
              value={issue.description || ''}
            />
          ) : (
            <Box borderBottom={1} borderColor="divider" minHeight="38px" alignContent="center">
              <Typography variant="body1">{issue.description || 'No description'}</Typography>
            </Box>
          )}
        </Grid>

        {!isNew && (
          <Grid size={2.5}>
            <EnumDropdown
              source={`status_${elementId}`}
              label="Status"
              value={issue.status || STAFFING_RISK_STATUS.ACTIVE}
              onChangeCallback={(event: any) => {
                if (isSystem) return;
                onStatusChange(index, event[`status_${elementId}`]);
              }}
              options={STAFFING_RISK_STATUS_DISPLAY}
              disabled={isSystem}
            />
          </Grid>
        )}

        <Grid size={2.5}>
          <EnumDropdown
            source={`zone_${elementId}`}
            label="Zone"
            value={issue.targetPriority || STAFFING_PRIORIRY_ZONES_ALIASES.SAFE}
            onChangeCallback={(event: any) => {
              const zone = event[`zone_${elementId}`];
              onZoneChange(index, zone);
            }}
            options={ZONE_LABELS}
            disabled={isSystem}
          />
        </Grid>

        {isNew && (
          <Grid size={1} display="flex" alignItems="center" justifyContent="flex-end" mt={0.5}>
            <Button
              color="primary"
              variant="contained"
              sx={{ minWidth: 'auto', px: 1 }}
              onClick={() => onRemove(index)}
              size="small"
            >
              <MinusIcon sx={{ fill: 'common.white' }} />
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default StaffingRiskIssueItem;
